import React from "react";
import Icon from "./Icon";

export const CalendarIcon = () => (
  <Icon>
    <path fillRule="evenodd" clipRule="evenodd" d="M19 4h-1V3a1 1 0 10-2 0v1H8V3a1 1 0 00-2 0v1H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2zm-6 5h3c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1z"/>
  </Icon>
);
